/**
 * Where a sign-in redirect is on its way to.
 *
 * Auth0 calls `onRedirectCallback` before it reports itself loaded, so the
 * `/callback` route can still render after `router.navigate` has moved the
 * URL — React Router resolves the navigation before the tree re-renders with
 * the new location. That render used to redirect to the dashboard and discard
 * wherever the sign-in came from; reading this instead sends it to the same
 * place, so the order stops mattering.
 *
 * Lives for the page load. `/callback` is only ever entered by a fresh
 * document load from Auth0, which resets this to null, so a stale target
 * cannot be read by a later visit.
 */
let pending: string | null = null;

/** Records the target before starting the navigation to it. */
export function rememberReturnTo(path: string): void {
  pending = path;
}

/** Reads without clearing: the callback route may render more than once. */
export function peekReturnTo(): string | null {
  return pending;
}

/** Resets between tests. Nothing in the apps clears it; a page load does. */
export function clearReturnTo(): void {
  pending = null;
}
